module.exports = __webpack_public_path__ + "img/DW365-159.ee328c24.jpg";